import { api } from "@/lib/api";

/**
 * "Espaços" — a UI dos PROJECTS do motor. DECISÃO DE PRODUTO: espaço é SÓ uma
 * forma de organizar o kanban (campanhas, produtos, frentes) — NÃO é uma nova
 * unidade organizacional. Onboarding, ESCALA, agentes e bases continuam sendo
 * por empresa; o espaço só agrupa/filtra tarefas.
 */
export type Espaco = {
  id: string;
  companyId: string;
  name: string;
  description: string | null;
  color: string | null;
  archivedAt: string | null;
  createdAt: string;
  updatedAt: string;
};

export const projectsApi = {
  list: (companyId: string) => api.get<Espaco[]>(`/companies/${companyId}/projects`),
  create: (companyId: string, input: { name: string; color?: string | null }) =>
    api.post<Espaco>(`/companies/${companyId}/projects`, input),
  update: (id: string, patch: { name?: string; color?: string | null; archivedAt?: string | null }) =>
    api.patch<Espaco>(`/projects/${id}`, patch),
};

/** Paleta de cores pros espaços (mesma família de acentos do app). */
export const ESPACO_COLORS = [
  "#fe7000", // laranja da marca
  "#0e7490", // petróleo
  "#8b5cf6", // violeta
  "#3aa657", // verde
  "#d92d4a", // vermelho
  "#e08a2b", // âmbar
  "#063e6e", // navy
] as const;
